<template>
    <main class="ui-page">
    <AppFilterToolbar v-if="canManage"><template #create><AppButton design="new" @click.native="editing = { isNew: true }">Create template</AppButton></template></AppFilterToolbar>
    <AppErrorState v-if="error" :message="error" icon-only @retry="load" />
    <AppContentSkeleton v-else-if="loading" label="Loading templates" :columns="columns" min-width="1200px" />
    <AppCard v-else-if="templates.length" design="new" variant="table" header-density="compact">
      <AppDataTable design="new" density="dense" :columns="columns" :rows="templates" row-key="id" min-width="1200px">
        <template #cell-name="{ row }"><AppTableText :text="row.name" /></template>
        <template #cell-kind="{ row }"><AppTableText :text="kindLabel(row.contact_type)" /></template>
        <template #cell-languages="{ row }"><AppTableText :text="row.texts.map(text => text.language_name).join(', ')" /></template>
        <template #cell-status="{ row }"><AppStatusBadge design="new" compact :tone="row.active ? 'green' : 'neutral'" :label="row.active ? 'Active' : 'Inactive'" /></template>
        <template #cell-actions="{ row }">
          <AppIconButton v-if="canManage" :label="`Edit ${row.name}`" @click="editing = row"><i class="pi pi-pencil" aria-hidden="true" /></AppIconButton>
        </template>
      </AppDataTable>
    </AppCard>
    <AppNoResults v-else design="new" title="No templates" text="" />
    <TemplateEditor v-if="editing" :template="editing" @close="editing = null" @saved="onSaved" />
    </main>
</template>

<script>
import { getCommunicationTemplates } from '@/http'
import AppContentSkeleton from '@/components/AppContentSkeleton.vue'
import AppErrorState from '@/components/AppErrorState.vue'
import AppIconButton from '@/components/AppIconButton.vue'
import AppTableText from '@/components/AppTableText.vue'
import { groundOpsKey } from '@/utils/groundOpsAccess'
import TemplateEditor from './TemplateEditor'

const COLUMNS = [
  { key: 'name', label: 'Template', width: '35%' },
  { key: 'kind', label: 'Suggested for', width: '22%' },
  { key: 'languages', label: 'Languages', width: '23%' },
  { key: 'status', label: 'Status', width: '12%' },
  { key: 'actions', label: '', width: '8%' }
]

export default {
  name: 'GroundOpsCommunicationTemplates',
  components: { AppContentSkeleton, AppErrorState, AppIconButton, AppTableText, TemplateEditor },
  data: () => ({ templates: [], loading: false, error: '', editing: null, columns: COLUMNS }),
  computed: {
    canManage() { return this.$store.getters['permissions/can'](groundOpsKey('communication', 'manage_templates')) }
  },
  created() { this.load() },
  methods: {
    kindLabel(kind) {
      return { welcome: 'Welcome', starts_tomorrow: 'Safari starts tomorrow', evening_follow_up: 'Evening follow-up' }[kind] || 'Any contact'
    },
    async load() {
      this.loading = true
      this.error = ''
      try {
        this.templates = (await getCommunicationTemplates()).data
      } catch (error) {
        this.error = 'Could not load templates.'
      } finally {
        this.loading = false
      }
    },
    onSaved() { this.editing = null; this.load() }
  }
}
</script>
